import * as TYPES from './types';
import { initialState } from '../health-summary-reducer';

export const optionsSelected = (options) => {
  const newOptions = { ...initialState.options, ...options };
  return ({
    type: TYPES.OPTIONS_SELECTED,
    state: {
      options: newOptions,
    },
  });
};

export const healthSummaryHtmlLoaded = (summary) => ({
  type: TYPES.HEALTH_SUMMARY_HTML_LOADED_SUCCESS,
  state: {
    healthSummaryHtml: summary,
  },
});

export const healthSummaryHtmlFailed = (message) => ({
  type: TYPES.HEALTH_SUMMARY_HTML_LOADED_FAILED,
  state: {
    error: message,
  },
});

export const healthSummaryDownloadPathSet = (path) => ({
  type: TYPES.HEALTH_SUMMARY_SET_DOWNLOAD_PATH,
  state: {
    downloadPath: path,
  },
});

export const healthSummaryListLoaded = (ccdaArray) => ({
  type: TYPES.HEALTH_SUMMARY_LIST_LOADED,
  state: {
    filteredCcdas: ccdaArray,
    healthSummaryHtml: null,
    currentIdentifier: null,
  },
});

export const healthSummaryListLoadFailed = (message) => ({
  type: TYPES.HEALTH_SUMMARY_LIST_LOAD_FAILED,
  state: {
    error: message,
  },
});

export const mostRecentHealthSummaryIdentifierLoaded = (identifier) => ({
  type: TYPES.MOST_RECENT_HEALTH_SUMMARY_LOADED_SUCCESS,
  state: {
    currentIdentifier: identifier,
  },
});

export const mostRecentHealthSummaryIdentifierFailed = (message) => ({
  type: TYPES.MOST_RECENT_HEALTH_SUMMARY_LOADED_FAILED,
  state: {
    error: message,
  },
});

export const clearLoadedHtml = () => ({
  type: TYPES.HEALTH_SUMMARY_CLEAR_LOADED_HTML,
});

export const recentOfficeVisitsLoaded = (recentVisits) => (
  {
    type: TYPES.RECENT_OFFICE_VISITS_LOADED_SUCCESS,
    state: {
      recentVisits,
    },
  }
);

export const recentOfficeVisitsFailed = () => ({
  type: TYPES.RECENT_OFFICE_VISITS_LOADED_FAILED,
  state: {
    recentVisits: [],
  },
});

export const updateHealthSummaryIdentifier = (identifier) => ({
  type: TYPES.HEALTH_SUMMARY_IDENTIFIER_UPDATE,
  state: {
    currentIdentifier: identifier,
    healthSummaryHtml: null,
    downloadPath: null,
  },
});
